import { compose } from 'js/utils/ramda.util';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { Loader } from 'js/components/common/Loader';
import React, { useEffect, useState, useCallback } from 'react';
import { componentService } from 'js/services/component.service';
import { withComponent } from 'js/components/hocs/withComponent';

import * as hooks from './hooks';
import * as constants from './constants';

import * as styles from './SportsbookBetconstruct.css';

export const SportsbookBetconstructBare = () => {
    const isMounted = useIsMounted();
    const [isLoading, setIsLoading] = useState(true);
    const initSportsbook = hooks.useInitSportsbook();

    const toggleLoading = useCallback(({ data }) => {
        if (data?.type === 'applicationReady' || data?.data?.type === 'applicationReady') {
            isMounted() && setIsLoading(false);
        }
    }, [setIsLoading, isMounted]);

    useEffect(() => {
        initSportsbook();
    }, [initSportsbook]);

    useEffect(() => {
        window.addEventListener('message', toggleLoading);

        return () => {
            window.removeEventListener('message', toggleLoading);
        };
    }, [toggleLoading]);

    hooks.useRemoveGetParameters();

    return (
        <>
            <div id={constants.SPORTSBOOK_HTML_CONTAINER_ID} className={`${styles.container} ${isLoading ? 'hidden' : ''}`} />
            {isLoading && <div className={styles.loadingContainer}><Loader /></div>}
        </>
    );
};

export const SportsbookBetconstruct = compose(
    withComponent()
)(SportsbookBetconstructBare);

componentService.registerPageComponents({ [constants.SPORTSBOOK_PORTLET_NAME]: SportsbookBetconstruct });
